import PropTypes from 'prop-types';
import React from 'react';

import LoginActions from '@/components/PageHeader/LoginActions/LoginActions';
import Link from '@/components/PageHeader/MobileHeader/MobileNavigation/Link/Link';

import MenuItem from '../MenuItem/MenuItem';
import { Level, Links } from '../MobileNavigation.style';

const Level1 = ({
  menuItems,
  navbarLinks,
  activeLevel,
  onClick,
  closeNavigation,
  loginMenuHidden,
}) => {
  return (
    <Level
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}>
      <Links active={activeLevel === 1}>
        {menuItems.map((link, index) => (
          <MenuItem
            item={link}
            onClick={onClick}
            closeNavigation={closeNavigation}
            key={index}
          />
        ))}
        {navbarLinks.map((item, index) => (
          <Link
            key={index}
            href={item.attributes.link}
            title={item.attributes.title}
            closeNavigation={closeNavigation}
            openInNewTab={item.attributes.openInNewTab}
          />
        ))}
      </Links>
      {!loginMenuHidden && (
        <LoginActions desktop={false} onAction={closeNavigation} />
      )}
    </Level>
  );
};

Level1.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      attributes: PropTypes.shape({
        title: PropTypes.string.isRequired,
      }).isRequired,
    })
  ),
  navbarLinks: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      attributes: PropTypes.shape({
        link: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
      }).isRequired,
    })
  ),
  activeLevel: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  closeNavigation: PropTypes.func.isRequired,
  loginMenuHidden: PropTypes.bool,
};

export default Level1;
